module.exports = __webpack_public_path__ + "static/use-case-7-content-5-52969d5fd9d31711c05b20b30fc7c1eb.png";